<template>
  <div class="business-opportunity-manage-container">
    <!-- 查询条件卡片 -->
    <el-card class="search-card">
      <div slot="header" class="flex justify-between items-center">
        <span>{{ $t("businessOpportunityManageMessages.search.title") }}</span>
      </div>
      <el-row :gutter="20" class="search-row">
        <el-col :span="6">
          <el-select
            v-model="conditions.source"
            :placeholder="$t('businessOpportunityManageMessages.search.source')"
            style="width: 100%"
            clearable
          >
            <el-option
              v-for="item in opportunityOptions"
              :key="item.statusCd"
              :label="item.description"
              :value="item.statusCd"
            />
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-select
            v-model="conditions.status"
            :placeholder="$t('businessOpportunityManageMessages.search.status')"
            style="width: 100%"
            clearable
          >
            <el-option
              v-for="item in statusOptions"
              :key="item.statusCd"
              :label="item.description"
              :value="item.statusCd"
            />
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-select
            v-model="conditions.responsiblePerson"
            :placeholder="
              $t('businessOpportunityManageMessages.search.responsiblePerson')
            "
            style="width: 100%"
            clearable
          >
            <el-option
              v-for="user in userOptions"
              :key="user.name"
              :label="user.name"
              :value="user.name"
            />
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-input
            v-model="conditions.customerName"
            :placeholder="
              $t('businessOpportunityManageMessages.search.keyword')
            "
            clearable
          />
        </el-col>
      </el-row>
      <el-row :gutter="20" class="search-row">
        <el-col :span="8">
          <el-date-picker
            v-model="dateRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="6">
          <div class="button-group">
            <el-button type="primary" @click="_businessOpportunityMethod">
              <i class="el-icon-search"></i>
              {{ $t("common.search") }}
            </el-button>
            <el-button @click="_resetBusinessOpportunityMethod">
              <i class="el-icon-refresh"></i>
              {{ $t("common.reset") }}
            </el-button>
            <el-button type="success" @click="_openAddBusinessOpportunityModal">
              <i class="el-icon-plus"></i>
              {{ $t("common.add") }}
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <div style="margin-bottom: 20px">
      <div class="data-cards" style="padding: 0">
        <!-- 总商机数卡片 -->
        <div class="data-card">
          <div class="card-info">
            <p class="card-title">总商机数</p>
            <p class="card-number">{{ stats.total_quantity || 0 }}</p>
            <p
              class="card-trend"
              :class="{
                'down-icon':
                  stats.total_quantity_percentage_compared_to_last_month < 0,
              }"
            >
              <span
                v-if="
                  stats.total_quantity_percentage_compared_to_last_month > 0
                "
                class="up-icon"
                >↑</span
              >
              <span
                v-if="
                  stats.total_quantity_percentage_compared_to_last_month < 0
                "
                class="down-icon"
                >↓</span
              >
              {{
                Math.abs(
                  stats.total_quantity_percentage_compared_to_last_month || 0,
                )
              }}% 较上月
            </p>
          </div>
          <div class="card-icon">
            <el-tooltip content="总商机数相关提示" placement="top">
              <i class="el-icon-s-opportunity"></i>
            </el-tooltip>
          </div>
        </div>
        <!-- 待跟进商机卡片 -->
        <div class="data-card">
          <div class="card-info">
            <p class="card-title">待跟进商机</p>
            <p class="card-number">{{ stats.pending_quantity || 0 }}</p>
            <p
              class="card-trend"
              :class="{
                'down-icon':
                  stats.pending_quantity_percentage_compared_to_last_month < 0,
              }"
            >
              <span
                v-if="
                  stats.pending_quantity_percentage_compared_to_last_month > 0
                "
                class="up-icon"
                >↑</span
              >
              <span
                v-if="
                  stats.pending_quantity_percentage_compared_to_last_month < 0
                "
                class="down-icon"
                >↓</span
              >
              {{
                Math.abs(
                  stats.pending_quantity_percentage_compared_to_last_month || 0,
                )
              }}% 较上月
            </p>
          </div>
          <div class="card-icon">
            <el-tooltip content="待跟进商机相关提示" placement="top">
              <i class="el-icon-time"></i>
            </el-tooltip>
          </div>
        </div>
        <!-- 已成交卡片 -->
        <div class="data-card">
          <div class="card-info">
            <p class="card-title">已成交</p>
            <p class="card-number">{{ stats.closed_quantity || 0 }}</p>
            <p
              class="card-trend"
              :class="{
                'down-icon':
                  stats.closed_quantity_percentage_compared_to_last_month < 0,
              }"
            >
              <span
                v-if="
                  stats.closed_quantity_percentage_compared_to_last_month > 0
                "
                class="up-icon"
                >↑</span
              >
              <span
                v-if="
                  stats.closed_quantity_percentage_compared_to_last_month < 0
                "
                class="down-icon"
                >↓</span
              >
              {{
                Math.abs(
                  stats.closed_quantity_percentage_compared_to_last_month || 0,
                )
              }}% 较上月
            </p>
          </div>
          <div class="card-icon">
            <el-tooltip content="已成交相关提示" placement="top">
              <i class="el-icon-success"></i>
            </el-tooltip>
          </div>
        </div>
        <div class="data-card empty-card"></div>
      </div>
    </div>

    <div style="margin-bottom: 15px">
      <el-row :gutter="20">
        <el-col :span="16">
          <div class="chart-item">
            <h3>商机趋势分析</h3>
            <div
              id="trendChart"
              class="chart"
              style="width: 100%; height: 400px"
            ></div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="chart-item">
            <h3>商机状态分布</h3>
            <div
              id="statusChart"
              class="chart"
              style="width: 100%; height: 400px"
            ></div>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 商机列表部分保持不变 -->
    <el-card class="list-card">
      <el-table
        :data="filteredBusinessOpportunities"
        border
        style="width: 100%"
        v-loading="tableLoading"
        element-loading-text="加载中..."
      >
        <el-table-column type="selection" align="center" width="60" />
        <el-table-column
          :label="$t('businessOpportunityManageMessages.table.opportunityName')"
          align="center"
          min-width="150"
        >
          <template slot-scope="scope">
            <div class="opportunity-name">{{ scope.row.opportunityName }}</div>
            <div class="opportunity-source">
              来源: {{ getSourceLabel(scope.row.source) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('businessOpportunityManageMessages.table.customerName')"
          align="center"
          min-width="120"
        >
          <template slot-scope="scope">
            <div class="customer-name">{{ scope.row.customerName }}</div>
            <div class="customer-contact">
              联系人: {{ scope.row.responsiblePerson }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="responsiblePerson"
          :label="
            $t('businessOpportunityManageMessages.table.responsiblePerson')
          "
          align="center"
          min-width="120"
        />

        <el-table-column
          prop="status"
          :label="$t('businessOpportunityManageMessages.table.status')"
          align="center"
          min-width="120"
        >
          <template slot-scope="scope">
            <el-tag :type="getStatusTagType(scope.row.status)" size="small">
              {{ getStatusLabel(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column
          prop="expectedDealDate"
          :label="
            $t('businessOpportunityManageMessages.table.expectedDealDate')
          "
          align="center"
          min-width="120"
        />
        <el-table-column
          :label="$t('common.operation')"
          align="center"
          min-width="200"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="_viewBusinessOpportunity(scope.row)"
              icon="el-icon-view"
            >
              {{ $t("common.view") }}
            </el-button>
            <el-button
              size="mini"
              type="primary"
              @click="_openEditBusinessOpportunityModel(scope.row)"
              icon="el-icon-edit"
            >
              {{ $t("common.edit") }}
            </el-button>
            <el-button
              size="mini"
              type="danger"
              @click="_openDeleteBusinessOpportunityModel(scope.row)"
              icon="el-icon-delete"
            >
              {{ $t("common.delete") }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页部分保持不变 -->
      <el-pagination
        :current-page.sync="page.current"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="page.size"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        class="pagination"
      />
    </el-card>

    <!-- 子组件部分保持不变 -->
    <add-business-opportunity
      ref="addBusinessOpportunity"
      :sourceOptions="opportunityOptions"
      :statusOptions="statusOptions"
      :userOptions="userOptions"
      :opportunityTypeOptions="opportunityTypeOptions"
      :negotiationProgressOptions="negotiationProgressOptions"
      :roomOptions="roomOptions"
      @success="handleSuccess"
    />
    <edit-business-opportunity
      ref="editBusinessOpportunity"
      :viewMode="isViewMode"
      :sourceOptions="opportunityOptions"
      :statusOptions="statusOptions"
      :userOptions="userOptions"
      :opportunityTypeOptions="opportunityTypeOptions"
      :negotiationProgressOptions="negotiationProgressOptions"
      :roomOptions="roomOptions"
      @success="handleSuccess"
    />
    <delete-business-opportunity
      ref="deleteBusinessOpportunity"
      @success="handleSuccess"
    />
  </div>
</template>

<script>
import {
  queryBusinessOpportunity,
  queryBusinessOpportunityEcharts,
  selectStaffInfos,
  getRoomInfoByCommunity,
} from "@/api/businessOpportunity/businessOpportunityApi";
import AddBusinessOpportunity from "@/components/businessOpportunity/addBusinessOpportunity";
import EditBusinessOpportunity from "@/components/businessOpportunity/editBusinessOpportunity";
import DeleteBusinessOpportunity from "@/components/businessOpportunity/deleteBusinessOpportunity";
import { getDict } from "@/api/community/communityApi";
import { getCommunityId } from "@/api/community/communityApi";
import * as echarts from "echarts";
export default {
  name: "BusinessOpportunityList",
  components: {
    AddBusinessOpportunity,
    EditBusinessOpportunity,
    DeleteBusinessOpportunity,
  },
  data() {
    return {
      communityId: "",
      // 新增统计数据对象
      stats: {
        closed_quantity_percentage_compared_to_last_month: 0,
        completed_counts: "",
        total_quantity_percentage_compared_to_last_month: 0,
        pending_quantity_percentage_compared_to_last_month: 0,
        total_quantity: 0,
        pending_quantity: 0,
        closed_quantity: 0,
      },
      // 其他数据保持不变
      tableLoading: false,
      businessOpportunities: [],
      statusNameList: [],
      statusCountList: [],
      searchText: "",
      isViewMode: false,
      dateRange: null,
      opportunityOptions: [],
      customerOptions: [],
      statusOptions: [],
      opportunityTypeOptions: [],
      negotiationProgressOptions: [],
      userOptions: [],
      newCountsList: [],
      completedCountsList: [],
      roomOptions: [],
      conditions: {
        source: "",
        status: "",
        responsiblePerson: "",
        customerName: "",
      },
      page: {
        current: 1,
        size: 10,
        total: 0,
      },
      trendChart: null,
      statusChart: null,
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleChartResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleChartResize);
    if (this.trendChart) {
      this.trendChart.dispose();
    }
    if (this.statusChart) {
      this.statusChart.dispose();
    }
  },
  computed: {
    filteredBusinessOpportunities() {
      if (!this.searchText) return this.businessOpportunities;

      const searchLower = this.searchText.toLowerCase();
      return this.businessOpportunities.filter(
        (item) =>
          item.opportunityName.toLowerCase().includes(searchLower) ||
          item.customerName.toLowerCase().includes(searchLower) ||
          item.responsiblePerson.toLowerCase().includes(searchLower),
      );
    },
  },
  created() {
    this._initData();
    this.communityId = getCommunityId();
  },
  methods: {
    /**
     * 初始化数据
     */
    async _initData() {
      try {
        this._listBusinessOpportunities(this.page.current, this.page.size);
        this._listBusinessOpportunitiesEcharts();
        this.getSourceOptions();
        this.getCustomerOptions();
        this.getOpportunityTypeOptions();
        this.getNegotiationProgressDict();
        this._selectStaffInfos();
        this.roomData();
      } catch (error) {
        console.error("初始化数据失败:", error);
      }
    },

    /**
     * 获取商机来源选项
     */
    async getSourceOptions() {
      try {
        const auditData = await getDict("business_opportunity_source", "audit");
        this.opportunityOptions = auditData;
      } catch (error) {
        console.error("获取来源选项失败:", error);
      }
    },
    async getOpportunityTypeOptions() {
      try {
        const auditData = await getDict("opportunity_type", "audit");
        this.opportunityTypeOptions = auditData;
      } catch (error) {
        console.error("获取来源选项失败:", error);
      }
    },

    async getNegotiationProgressDict() {
      try {
        const auditData = await getDict("negotiation_progress", "audit");
        this.negotiationProgressOptions = auditData;
      } catch (error) {
        console.error("获取来源选项失败:", error);
      }
    },

    async getCustomerOptions() {
      try {
        const auditData = await getDict("business_opportunity_status", "audit");
        this.statusOptions = auditData;
      } catch (error) {
        console.error("获取状态选项失败:", error);
      }
    },

    /**
     * 获取商机列表数据
     */
    async _listBusinessOpportunities(page, size) {
      try {
        this.tableLoading = true;

        const params = {
          page,
          row: size,
          ...this.conditions,
          // 添加开始时间和结束时间（根据接口字段名调整）
          startTime: this.dateRange ? this.dateRange[0] : null,
          endTime: this.dateRange ? this.dateRange[1] : null,
        };

        // 注意：如果接口需要时间戳或特定格式，需转换
        // 例如：将Date对象转为yyyy-MM-dd HH:mm:ss字符串
        if (params.startTime) {
          params.startTime = this.formatDate(params.startTime);
        }
        if (params.endTime) {
          params.endTime = this.formatDate(params.endTime);
        }

        const { data, total } = await queryBusinessOpportunity(params);
        this.businessOpportunities = data || [];
        this.page.total = total || 0;
      } catch (error) {
        this.$message.error(
          this.$t("businessOpportunityManageMessages.fetchError"),
        );
        console.error("获取商机列表失败:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    async _listBusinessOpportunitiesEcharts() {
      try {
        this.tableLoading = true;
        // 调用接口获取数据
        const { data } = await queryBusinessOpportunityEcharts();

        // 保存统计数据到stats对象
        this.stats = {
          closed_quantity_percentage_compared_to_last_month:
            data.closed_quantity_percentage_compared_to_last_month || 0,
          completed_counts: data.completed_counts || "",
          total_quantity_percentage_compared_to_last_month:
            data.total_quantity_percentage_compared_to_last_month || 0,
          pending_quantity_percentage_compared_to_last_month:
            data.pending_quantity_percentage_compared_to_last_month || 0,
          total_quantity: data.total_quantity || 0,
          pending_quantity: data.pending_quantity || 0,
          closed_quantity: data.closed_quantity || 0,
        };

        // 处理图表数据
        let completedCounts = [];
        let newCounts = [];

        // 转换已转化商机数据
        if (typeof data.completed_counts === "string") {
          completedCounts = data.completed_counts.split(",").map(Number);
        } else if (Array.isArray(data.completed_counts)) {
          completedCounts = data.completed_counts.map(Number);
        } else {
          completedCounts = Array(12).fill(0);
        }

        // 转换新增商机数据（假设接口返回new_counts字段）
        if (typeof data.new_counts === "string") {
          newCounts = data.new_counts.split(",").map(Number);
        } else if (Array.isArray(data.new_counts)) {
          newCounts = data.new_counts.map(Number);
        } else {
          newCounts = Array(12).fill(0);
        }

        // 控制台输出验证
        console.log("111", completedCounts);
        console.log("asd", newCounts);

        // 处理状态分布数据
        const statusNames = data.statusNameList || [];
        let statusCounts = [];

        if (typeof data.statusCountList === "string") {
          statusCounts = data.statusCountList.split(",").map(Number);
        } else if (Array.isArray(data.statusCountList)) {
          statusCounts = data.statusCountList.map(Number);
        } else {
          statusCounts = [2, 5, 3, 4, 3, 1];
        }

        const chartData = {
          newCounts,
          completedCounts,
          statusNames,
          statusCounts,
        };

        this.initTrendChart(chartData);
        this.initStatusChart(chartData);
      } catch (error) {
        this.$message.error(
          this.$t("businessOpportunityManageMessages.fetchError"),
        );
        console.error("获取商机图表数据失败:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    /**
     * 其他方法保持不变
     */
    _businessOpportunityMethod() {
      this.page.current = 1;
      this._listBusinessOpportunities(this.page.current, this.page.size);
    },

    _resetBusinessOpportunityMethod() {
      this.conditions = {
        customerName: "",
        status: "",
        responsiblePerson: "",
        source: "", // 补充重置来源字段
      };
      this.dateRange = null; // 重置日期范围
      this.searchText = "";
      this.page.current = 1;
      this._listBusinessOpportunities(this.page.current, this.page.size);
    },

    _openAddBusinessOpportunityModal() {
      this.$refs.addBusinessOpportunity.open();
    },

    _openEditBusinessOpportunityModel(row) {
      this.isViewMode = false;
      this.$refs.editBusinessOpportunity.open(row);
    },

    _openDeleteBusinessOpportunityModel(row) {
      this.$refs.deleteBusinessOpportunity.open(row);
    },

    _viewBusinessOpportunity(row) {
      this.isViewMode = true;
      this.$refs.editBusinessOpportunity.open(row);
    },

    handleSizeChange(val) {
      this.page.size = val;
      this._listBusinessOpportunities(this.page.current, this.page.size);
    },

    handleCurrentChange(val) {
      this.page.current = val;
      this._listBusinessOpportunities(this.page.current, this.page.size);
    },

    handleSuccess() {
      // 1. 刷新商机列表数据
      this._listBusinessOpportunities(this.page.current, this.page.size);
      // 2. 新增：刷新统计数据和图表（删除后统计数据会变化）
      this._listBusinessOpportunitiesEcharts();
    },
    getStatusLabel(status) {
      const matchOption = this.statusOptions.find(
        (option) => option.statusCd === status,
      );
      return matchOption ? matchOption.description : status;
    },

    getSourceLabel(source) {
      const matchOption = this.opportunityOptions.find(
        (option) => option.statusCd === source,
      );
      return matchOption ? matchOption.description : source;
    },

    getStatusTagType(status) {
      const statusMap = {
        initial_contact: "info",
        demand_confirmation: "primary",
        solution_making: "warning",
        business_negotiation: "purple",
        closed_won: "success",
        closed_lost: "danger",
      };
      return statusMap[status] || "default";
    },

    async _selectStaffInfos() {
      try {
        const params = {
          page: 1,
          row: 1000,
          ...this.conditions,
        };
        const auditData = await selectStaffInfos(params);

        if (auditData.total === 0) {
          this.userOptions = [];
        } else {
          this.userOptions = auditData.staffs || [];
        }
      } catch (error) {
        this.$message.error(
          this.$t("businessOpportunityManageMessages.fetchError"),
        );
        console.error("获取员工信息失败:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    async roomData() {
      try {
        const params = { communityId: this.getCommunityId() };
        const res = await getRoomInfoByCommunity(params);
        this.roomOptions = Array.isArray(res) ? res : res.data || [];
        console.log("房源数据:", this.roomOptions);
      } catch (error) {
        console.error("房源数据加载异常:", error);
        this.$message.error("加载房源失败");
        this.roomOptions = [];
      }
    },
    formatDate(date) {
      if (!(date instanceof Date)) return "";
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    // 初始化“商机趋势分析”柱状图
    initTrendChart(chartData) {
      const { newCounts, completedCounts } = chartData;
      const chartDom = document.getElementById("trendChart");
      this.trendChart = this.trendChart || echarts.init(chartDom);

      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "shadow" },
          formatter: "{b}<br/>{a0}: {c0}<br/>{a1}: {c1}",
        },
        legend: {
          data: ["新增商机", "已转化商机"],
        },
        xAxis: {
          type: "category",
          data: [
            "1月",
            "2月",
            "3月",
            "4月",
            "5月",
            "6月",
            "7月",
            "8月",
            "9月",
            "10月",
            "11月",
            "12月",
          ],
        },
        yAxis: {
          type: "value",
          min: 0,
          interval: 1,
        },
        series: [
          {
            name: "新增商机",
            type: "bar",
            data: newCounts,
            itemStyle: { color: "#409EFF" },
          },
          {
            name: "已转化商机",
            type: "bar",
            data: completedCounts,
            itemStyle: { color: "#48C9B0" },
          },
        ],
      };

      this.trendChart.setOption(option);
    },

    // 初始化“商机状态分布”环形图
    initStatusChart(chartData) {
      const { statusNames, statusCounts } = chartData;
      const chartDom = document.getElementById("statusChart");
      this.statusChart = this.statusChart || echarts.init(chartDom);

      const formattedData = statusNames.map((name, index) => ({
        name,
        value: statusCounts[index],
      }));

      // 生成随机颜色的函数
      const getRandomColor = () => {
        // 随机生成 RGB 颜色（避免过暗或过亮，范围控制在 50-200 之间）
        const r = Math.floor(Math.random() * 150) + 50;
        const g = Math.floor(Math.random() * 150) + 50;
        const b = Math.floor(Math.random() * 150) + 50;
        return `rgb(${r}, ${g}, ${b})`;
      };

      // 为每个类别预生成唯一随机色（避免hover时颜色变化）
      const colorMap = {};
      statusNames.forEach((name) => {
        colorMap[name] = getRandomColor();
      });

      const option = {
        tooltip: { trigger: "item", formatter: "{b}: {c} ({d}%)" },
        legend: {
          orient: "vertical",
          left: "left",
          data: statusNames,
        },
        series: [
          {
            name: "商机状态",
            type: "pie",
            radius: ["40%", "70%"],
            data: formattedData,
            itemStyle: {
              color: (params) => {
                // 使用预生成的随机色（保证同一类别颜色一致）
                return colorMap[params.name];
              },
            },
          },
        ],
      };

      this.statusChart.setOption(option);
    },

    handleChartResize() {
      if (this.trendChart) {
        this.trendChart.resize();
      }
      if (this.statusChart) {
        this.statusChart.resize();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.business-opportunity-manage-container {
  padding: 20px;
  background-color: #f5f7fa;

  .search-card {
    margin-bottom: 20px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);

    .search-row {
      margin-top: 15px;
    }

    .button-group {
      display: flex;
      gap: 10px;
    }
  }

  .list-card {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);

    .table-tools {
      margin-bottom: 15px;
      display: flex;
      justify-content: flex-end;
    }

    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
}

::v-deep .el-table {
  margin-top: 10px;
}

::v-deep .el-tag {
  padding: 2px 8px;
}

.list-cards {
  padding: 0px;
  box-shadow: none;
  border: none;
  background-color: #f5f7fa;
}
.data-cards {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  background-color: #f5f7fa;
}
.data-card {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background-color: white;
}
.card-info {
  display: flex;
  flex-direction: column;
}
.card-title {
  font-size: 14px;
  color: #606266;
  margin-bottom: 5px;
}
.card-number {
  font-size: 30px;
  font-weight: bold;
  color: #303133;
  margin: 0px 5px;
}
.card-trend {
  font-size: 12px;
  color: #67c23a;
}
.up-icon {
  color: #67c23a;
}
// 新增下降趋势样式
.down-icon {
  color: #f56c6c;
}
.card-icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.card-icon .el-icon-s-opportunity {
  background-color: rgba(147, 205, 255, 0.2);
  color: #409eff;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}
.card-icon .el-icon-time {
  background-color: rgba(255, 205, 100, 0.2);
  color: #f56c6c;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}
.card-icon .el-icon-success {
  background-color: rgba(100, 255, 150, 0.2);
  color: #67c23a;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}
.chart-item {
  flex: 1;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background-color: white;
}
.chart-item h3 {
  margin-bottom: 15px;
  font-size: 16px;
  font-weight: 500;
  color: #303133;
  text-align: left;
}
.chart-card {
  border: none;
  box-shadow: none;
}

.empty-card {
  background-color: #f5f7fa;
  border: none;
  box-shadow: none;
}
</style>
